var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2600_41285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.999 22C6.47602 22 1.99902 17.523 1.99902 12C1.99902 6.477 6.47602 2 11.999 2C17.522 2 21.999 6.477 21.999 12C21.999 17.523 17.522 22 11.999 22ZM11.002 16L18.072 8.929L16.658 7.515L11.002 13.172L8.17302 10.343L6.75902 11.757L11.002 16Z",
    fill: "#22C55E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2600_41285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBadge);
export default __webpack_public_path__ + "static/media/success_badge.f995c994f6c71bf29032d39a08d2e6c0.svg";
export { ForwardRef as ReactComponent };